<template>
    <div>
        <el-card>
            <div class="title">历史信息记录</div>
            <div v-for="(item,index) in historyList" :key="index">
                <div class="content">
                    <span>{{item.Version}}</span>
                    <div>
                        <span>修改时间:{{item.UpdateTime}}<span class="showAnotherColor" @click="backRenew(item)" v-show="index>0">恢复该版本</span></span>
                        <!-- <span>{{item.Title}}</span> -->
                        <router-link :to="{ path: '/knowledgeDetail',
                                        query:{KnowledgeId:item.KnowledgeId,Version:item.Version} }">
                            <span class="showAnotherColor">{{item.Title}}</span>
                        </router-link>
                        <div>
                            <span>作者:{{item.UpdateUser}}</span>
                            <span>更新者:{{item.UpdateUser}}</span>
                        </div>
                    </div>
                </div>
                <el-divider></el-divider>
            </div>
            <el-pagination @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="form.pageIndex"
                :page-sizes="[10,20]"
                :page-size="form.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </el-card>
    </div>
</template>

<script>

    import services from "./knowledge.service";
    export default {
        data: function () {
            return {
                form:{
                    KnowledgeId:'',
                    pageIndex:1,
                    pageSize:10
                },
                total:5,
                historyList:[]
            }
        },
        computed:{
            query:function () {
                return this.$route.query
            },
            KnowledgeId:function () {
                return this.query.KnowledgeId
            },
        },
        created(){
            this.getHistory();
        },
        methods:{
            getHistory(){//根据关键字查询
                this.form.KnowledgeId = this.KnowledgeId;
                services.knowledgeHistory(this.form).then(res=>{
                    this.historyList = res.KnowledgeHistoryTable;
                    this.total = res.total;
                })
            },
            handleSizeChange(val){
                let pages = Math.ceil(this.total / val);
                this.form.pageSize = val;
                if(this.form.pageIndex > pages ){
                    this.form.pageIndex  = 1;
                };
                this.getHistory();
            },
            handleCurrentChange(val){
                this.form.pageIndex = val;
                this.getHistory();
            },
            backRenew(data){//恢复版本
                let param = {
                    KnowledgeId:data.KnowledgeId,
                    Version:data.Version,
                    UpdateUser:localStorage.internalUserid,
                }
                services.knowledgeBackRenew(param).then(res=>{
                    this.$message.success("问题修改成功");
                    this.getHistory();
                })
            }
        }
    }

</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .title{
        margin: 20px 0 25px 10px;
    }
    .content{
        display: flex;
        &>span{
            margin-left: 10px;
        }
        &>div{
            margin-left: 20px;
            display: flex;
            flex-direction: column;
            &>span:nth-child(1){
                margin-bottom: 10px;
                &>span{
                    margin-left: 20px;
                }
            }
            &>div{
                margin-top: 10px;
                &>span:nth-child(1){
                    margin-right: 20px;
                }
            }
        }
    }
    .showAnotherColor{
        color:#1C86EE;
    }
</style>
